<template>
  <div>
    <div class="modal_header">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple">
            <div class="title_h" style="display: inline-block">
              <span> {{ $t("message.new_order") }}</span>
            </div>
            <div style="display: inline-block">
              <span class="ml-4">
                <el-tag class="mr-2">{{ $t("message.quantity") }}: {{ items.length }}</el-tag>
                <el-tag class="mr-2" type="success">{{ $t("message.total_amount") }}:
                  {{ Math.round(totalAmount) | formatMoney }}</el-tag>
                <el-tag>{{ $t("message.id_number") }}:
                  {{ this.old_order ? this.old_order.id : "" }}</el-tag>
              </span>
            </div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple-light">
            <el-row class="button_r">
              <el-button type="primary" @click="openOrderPaymentModal" :disabled="!isPayAble || old_order.payment_status === 'paid'">{{ $t(`message.pay`) }}</el-button>
              <el-button :loading="waitingPrint" :disabled="saveBtn" type="success" @click="printMini(printModel.id)">{{
                $t("message.print") }}</el-button>
              <el-button :loading="waitingPrint" :disabled="saveBtn" @click="print(printModel.id)">{{
                $t("message.print") }}</el-button>
              <el-button type="danger" @click="resetForm()">{{
                  $t("message.reset") }}</el-button>
              <el-button v-if="!old_save" :loading="waiting" @click="submit(false)"
                type="primary">{{ $t("message.save") }}
              </el-button>
              <el-button v-if="old_save" :loading="waiting" @click="updatingOrder(false)" type="primary">{{
                $t("message.update") }}
              </el-button>
              <el-button :loading="waiting" @click="closeForm()">{{
                $t("message.close")
              }}</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row :gutter="16">
      <el-col :span="16">
        <div class="grid-content">
          <div class="add_patient relative p-3">

            <div v-click-outside="closeModal">
              <el-form ref="form" class="from_x">
                <div class="col-label">
                  <el-form-item :label="$t(`message.search_patient`)" prop="searchP">
                    <el-input v-model="search" @input="searchPatients" clearable
                      @focus="isActiveModal = true"/>
                  </el-form-item>
                </div>
              </el-form>

              <div class="absolute-modal w-25" v-if="(yes_user || patients.length) && isActiveModal">
                <div class="old_patient mb-2" v-if="yes_user">
                  <div class="info_old_patient action" :class="{ active: infoOldSelected }">
                    <a class="cursor-pointer">
                      <span>{{ user.first_name }} {{ user.surname }}
                        {{ user.patronymic }}</span>
                      <span v-if="user.organization" class="tel_infos">
                        <i class="flaticon-call mr-1"></i> {{ user.phone }}
                        <i class="flaticon-home mr-1 ml-2"></i>
                        {{ user.organization.company_name }}</span>
                      <span v-else class="tel_infos">
                        <i class="flaticon-call mr-1"></i>
                        {{ user.phone }}</span>
                    </a>
                  </div>
                </div>
                <template v-else>
                  <div class="old_patient" v-for="patient in patients" :key="patient.id">
                    <div class="info_old_patient" :class="{ active: infoOldSelected }">
                      <a class="mb-2" @click="edit(patient);addClass();">
                        <span>
                          {{ patient.surname }} {{ patient.first_name }}
                          {{ patient.patronymic }}
                          <small> {{ patient.id }}</small></span>
                        <span v-if="patient.organization" class="tel_infos">
                          <i class="flaticon-call mr-1"></i>
                          {{ patient.phone }}
                          <i class="flaticon-home mr-1 ml-2"></i>
                          {{ patient.organization.company_name }}</span>
                        <span v-else class="tel_infos">
                          <i class="flaticon-call mr-1"></i>
                          {{ patient.phone }}</span>
                      </a>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- Регистрация -->
    <CrmCreate class="pl-3 pr-3" :patient.sync="patient"/>
    <el-row>
      <el-col :span="4">
        <el-button
          type="primary"
          class="ml-3 w-50"
          @click="openServiceModal"
          size="mini"
        >{{
            $t(`message.services`)
          }}</el-button>
      </el-col>
    </el-row>
    <!-- Таблица -->
    <NewOrderTable class="pl-3 pr-3" :items.sync="items"/>

    <el-drawer
      size="30%" :wrapperClosable="false"
      :visible.sync="drawerService.create.status"
      :ref="drawerService.create.name"
      :append-to-body="true"
      @opened="drawerOpened(drawerService.create.component)"
      @closed="drawerClosed(drawerService.create.component)"
    >
      <CreatePatientServiceUnpacked
        :ref="drawerService.create.component"
        :driver="drawerPatientService"
        :doctor_id="doctor_id"
        @items="itemsChanged"
        @owner_branch_id="getOwnerBranch"
        :drawer-name="drawerService.create.name"
      />
    </el-drawer>

    <el-dialog
      :title="$t(`message.pay`)"
      :visible.sync="orderPaymentVisible"
      :append-to-body="true"
    >
      <OrderPaymentDialog :order="old_order" ref="OrderPaymentModal"/>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import order from "@/utils/mixins/order";
import patient from "@/utils/mixins/patient";
import users from "@/components/selects/user_list";
import CrmShow from "./crm-show";
import partnerDoctors from "@/components/inventory-select/partner-doctor";
import drawer from "@/utils/mixins/drawer";
import CrmPriceInput from "@/components/crm/include/crm-price-input";
import CrmCreate from "@/views/patient/components/crm-create-2.vue";
import CreatePatientServiceUnpacked from "@/views/scheduler/create-patient-service-unpacked.vue";
import NewOrderTable from "./newOrderTable.vue";
import _ from "lodash";

export default {
  mixins: [order, drawer, patient],
  props: ["currentPatient"],
  components: {
    CrmShow,
    users,
    partnerDoctors,
    CrmPriceInput,
    NewOrderTable,
    CreatePatientServiceUnpacked,
    CrmCreate,
  },
  data() {
    return {
      RoomName: "",
      RoomNumber: "",
      isActiveModal: false,
      old_save: false,
      specialty_id: null,
      old_order: {},
      infoOldSelected: false,
      drawerShow: false,
      reopenShow: false,
      saveBtn: true,
      printModel: {},
      owner_branch_id: null,
      express_check: false,
      reopenUpdate: false,
      reloadList: false,
      room: null,
      doctor_id: null,
      drawerDepartment: false,
      attributes: {},
      searchServices: "",
      patient: null,
      defaultProps: {
        children: "children",
        label: "label",
        price: "price",
      },
      orderPaymentVisible: false,
      isPayAble: false,
    };
  },
  watch: {
    searchServices(val) {
      this.$refs.items.filter(val);
    },
    search() {
      this.infoOldSelected = false;
    },
    open: {
      handler: function (newVal, oldVal) {
        if (newVal === true) {
          this.setNewOrderData();
        }
      },
      deep: true,
      immediate: true,
    },
    conditions: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.form.condition_id = this.conditions[0].id;
        }
      },
      deep: true,
    },
    patient: {
      handler: _.debounce(function (newVal, oldVal) {
        this.$store.commit('services/SET_RESIDENCE_STATUS', (newVal.state_id === this.owner_clinic.state_id));
        if (newVal.state_id !== 191) {
          this.items.forEach(item => {
            if (item.is_secondary === false) {
              if (item.resident_price !== '0') item.price = item.resident_price;
            } else if (item.is_secondary === true) {
              if (item.secondary_resident_price !== '0') item.price = item.secondary_resident_price;
            }
          })
        } else if (newVal.state_id === 191) {
          this.items.forEach(item => {
            if (item.is_secondary === false) {
              item.price = (item.discount_price ? item.discount_price : item.origin_price);
            } else if (item.is_secondary === true) {
              item.price = (item.secondary_discount_price ? item.secondary_discount_price : item.secondary_price);
            }
          })
        }
      }, 1000),
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      orderColumns: "orderColumn/list",
      insuranceCompanies: "insuranceCompany/list",
      contractServiceList: "contracts/contract_services",
      residence_status: "services/is_residence",
      specialties: "specialties/list",
      workTimes: "workTimes/inventory",
      rules: "orders/rules",
      express: "expresses/list",
    }),
  },
  mounted() {
    if (this.workTimes && this.workTimes.length === 0) this.setworkTimes();
    const order_column_query = {
      get_actives: true,
      place: "is_register",
      per_page: 1000000,
    };
    this.getOrderColumns(order_column_query);
    this.getInsuranceCompany();
    this.getSpecialties();
    if (this.express && this.express.length === 0) this.loadExpress();
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions({
      getInsuranceCompany: "insuranceCompany/index",
      getOrderColumns: "orderColumn/index",
      updateSetlist: "services/updateSetlist",
      setworkTimes: "workTimes/inventory",
      loadExpress: "expresses/index",
      editService: "services/show",
      getSpecialties: "specialties/index",
      contractServices: "contracts/contractServices",
      discountPatient: "discountPatients/show",
      showModel: "conclusions/show",
      save: "orders/store",
      update: "orders/update",
      saveList: "services/setlist",
      emptyPatient: "patients/empty",
    }),
    getOwnerBranch(val) {
      this.owner_branch_id = val;
    },
    filterNode(value, data) {
      if (!value) return true;
      let dd = data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      return dd;
    },
    addClass() {
      this.infoOldSelected = true;
    },
    async show(model) {
      this.$loadingCursor("wait");
      await this.showModel(model.id)
        .then((res) => {
          this.$loadingCursor("default");
          this.drawerShow = true;
        })
        .catch((err) => {
          this.$loadingCursor("default");
        });
    },
    expressPrice(is_express) {
      if (is_express) {
        return 1 + this.express[0].percent / 100;
      } else {
        return 1;
      }
    },
    itemsChanged(val) {
      this.items = JSON.parse(JSON.stringify(val));
    },
    fetchData() {},
    setNewOrderData() {
      this.form = JSON.parse(JSON.stringify(this.model));
      this.form.day = new Date();
    },
    closeModal() {
      this.isActiveModal = false
    },
    submit(close) {
      this.changeWaiting(true);

      if (this.user !== null) {
        this.form.patient_id = this.user ? this.user.id : null;
        this.form.patient = this.user;
      } else if (this.patient !== null) {
        this.form.patient = this.patient;
        if (
          !this.isValidLocationSelection(
            this.form.patient.state_id,
            this.form.patient.region_id,
            this.form.patient.city_id
          )
        ) {
          this.changeWaiting();
          return;
        }
      }

      this.form.services = this.items;
      this.form.owner_branch_id = this.owner_branch_id;
      this.form.order_attributes = this.attributes;
      this.save(this.form)
        .then((res) => {
          this.old_save = true;
          this.old_order = res.data.order;
          this.isPayAble = true;
          this.form.patient_id = this.form.patient.id = res.data.order.patient_id;
          this.changeWaiting();
          this.saveBtn = false;
          this.printModel = res.data ? res.data.order : null;
          this.$notify({
            title: "Успешно",
            type: "success",
            offset: 130,
            message: res.message,
          });
        })
        .catch((err) => {
          this.changeWaiting();
          this.ifValidationError(err);
        });
    },
    updatingOrder(close) {
      this.changeWaiting(true);
      this.form.id = this.old_order.id;
      this.form.services = this.items;

      this.update(this.form)
        .then((res) => {
          this.changeWaiting();
          this.saveBtn = false;
          this.printModel = res.data ? res.data.order : null;
          this.$notify({
            title: "Успешно",
            type: "success",
            offset: 130,
            message: res.message,
          });
        })
        .catch((err) => {
          this.changeWaiting();
          this.ifValidationError(err);
        });
    },
    closeForm() {
      this.old_order = {};
      this.old_save = false;
      this.empty();
      this.$emit("c-close", { reload: false, drawer: this.drawer });
    },
    resetForm() {
      this.setNewOrderData();
      this.user = {};
      this.noUser();
      this.emptySearch();
      this.emptyList();
      this.old_order = {};
      this.old_save = false;
      this.search = "";
      this.saveBtn = true;
      this.latestServices.order_services = [];
      this.discountPatients = [];
      this.items = [];
      this.empty();
    },
    empty() {
      this.activeTab = "first";
      this.emptyList();
      this.emptySearch();
      this.emptyPatient();
      this.noUser();
      this.user = null;
      this.patient = null;
      this.patientServiceId = "";
      this.search = "";
      this.saveBtn = true;
      this.latestServices.order_services = [];
      this.discountPatients = [];
      this.items = [];
    },
    listChanged() {
      this.reloadList = true;
    },
    parent() {
      return this.$parent.$parent;
    },
    emptyModel() {
      this.empty_conclusions();
    },
  },
};
</script>
<style lang="scss">
.tableKa .el-table_1_column_7 .cell {
  display: block !important;
}

.bemor_uslugalar {
  text-decoration: none;
  list-style: none;
  margin: 0px;
  padding: 0px;

  li {
    border-bottom: 1px solid #dcdfe6;
    line-height: 19px;
    padding: 5px 0;
  }

  div {
    font-weight: 600;
  }

  span {
    text-align: right;
    width: 100%;
    display: block;
  }

  .col__red span {
    color: red;
  }
}

.ow_hiddin {
  height: 50vh;
  overflow-y: scroll;
}

.ow_hiddin::-webkit-scrollbar {
  width: 8px;
}

.ow_hiddin::-webkit-scrollbar-track {
  // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #fff;
}

.ow_hiddin::-webkit-scrollbar-thumb {
  background-color: #1f75a8;
  border-radius: 20px;
}

.my_add_pats {
  margin: 10px 0 20px 0;
}

.border-r-gray {
  border-right: 1px solid #dcdfe6;
}

.new_room {
  display: flex;
  width: 100%;
  align-items: center;
  height: 50px;
  /* background: #dcdfe6; */
  border-bottom: 1px solid #dcdfe6;
}

.room_number_title {
  margin-left: 10px;
  font-weight: 600;
}

.my-100 {
  .el-select {
    width: 100%;
  }

  .add_pats {
    margin-top: 0px;
  }
}
.absolute-modal {
  z-index: 200 !important;
}
</style>